import { API } from '../../lib/api/api';
import axios from 'axios';

export const getSubscriptionInvoices = async (subscriptionId: string) => {
	try {
		const res = await axios.get(
			`${API}user/stripe/getSubscriptionInvoices/?subscriptionId=${subscriptionId}`
		);
		return res;
	} catch (e) {
		return {
			data: e,
			error: e,
			status: 'error',
			statusText:
				'There has been an error retrieving your Copy and Post subscription details. Please contact support.'
		};
	}
};
